/* nutrae-template-extras.js — company-template mailing additions (2026-08-13).
 * ADDS: subscribe-success thank-you banner + confetti, and the ?science-letter=1
 * hook that auto-opens the mailing popup. Decorative/additive only — the theme
 * works unchanged without this file. Rollback = remove this script tag + file. */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    try {
      var params = new URLSearchParams(window.location.search);

      /* Subscribe success: thank-you + confetti */
      if (params.get('customer_posted') === 'true') {
        var banner = document.getElementById('NutraeSignupThanks');
        if (banner) {
          banner.removeAttribute('hidden');
          var btn = document.getElementById('NutraeSignupThanksClose');
          if (btn) {
            btn.addEventListener('click', function () {
              banner.setAttribute('hidden', '');
            });
          }
        }
        if (typeof window.geroConfetti === 'function') {
          window.geroConfetti({ colors: ['#b79359', '#ecd1a8', '#ffffff', '#063426'] });
        }
      }

      /* Science-letter hook: ?science-letter=1 auto-opens the signup modal */
      if (params.get('science-letter') === '1' && window.customElements) {
        customElements.whenDefined('signup-modal').then(function () {
          var m = document.querySelector('signup-modal');
          if (m && typeof m.show === 'function') {
            setTimeout(function () { m.show(); }, 400);
          }
        });
      }
    } catch (e) { /* additive only — never break the page */ }
  });
})();
